export class MetrcFormPayload {
  key = ''
}

export class BioTrackFormPayload {
  username = ''
  password = ''
  ubi = ''
  licenseIds: number[] = []
}

export class DutchieFormPayload {
  key = ''
  licenseIds: number[] = []
}

type LicenseMetrcValidationPassed = {
  licenseId: number
  licenseNumber: string
  licenseName: string
  companyName: string
}

type LicenseMetrcValidationFailed = {
  licenseId: number
  licenseNumber: string
  licenseName: string
  companyName: string
  message: string
  retryable: boolean
}

export type BankKeySetupResponse = {
  passedValidation?: LicenseMetrcValidationPassed[]
  failedValidation?: LicenseMetrcValidationFailed[]
  message?: string
}
